import React from "react";
import { Fieldset, Label, Select } from "@ui-kit/form";

type Option = { value: string; label: string };

export interface IProps {
  label?: string;
  value: Option;
  options: Option[];
  onChange: (id: Option) => void;
  isDisabled?: boolean;
}

const PanelsCardEditionSidebarDropdown = ({
  options,
  value,
  onChange,
  label,
  isDisabled,
}: IProps) => (
  <Fieldset>
    <Label>{label}</Label>
    <Select
      value={value}
      options={options}
      variant="primary"
      onChange={onChange}
      isSearchable={false}
      isDisabled={isDisabled}
    />
  </Fieldset>
);

export default PanelsCardEditionSidebarDropdown;
